import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import InfoGenesis from "../../../assets/img/Featured/tablet-info-genesis.png";
import IGKiosk from "../../../assets/img/Featured/kiosk-checkout.png";
import IGPanOpticKiosk from "../../../assets/img/Featured/kiosk-panoptic.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";
const MarketplacePage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page marketplacePage">
            <Header />
            <div className="page-header">Business & Industry Dining</div>
            <div className="text-wrapper">
                <div className="top">
                    <div className="topic-header">Marketplace</div>
                    <HorizontalLine />
                </div>
                <div className="std-text">
                    Expand access beyond peak hours with grab-and-go 
                    options and advanced self-checkout. These self-service 
                    models support preference-driven dining by giving 
                    employees more flexibility and autonomy without 
                    increasing staff demands.{'\n\n'}
                </div>
                <div className="std-text">
                    By easing congestion during busy periods and enabling 
                    quick, convenient transactions, operators can improve 
                    flow, reduce labor strain, and enhance the overall 
                    corporate dining experience.
                </div>
            </div>

            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Business & Industry Dining - Marketplace", "InfoGenesis");
                    addFlow("InfoGenesis");
                    navigate("/solutions/info-genesis")}}>
                    <div className="item-head">
                        <LogoMini />
                        InfoGenesis
                    </div>
                    <img src={InfoGenesis} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Business & Industry Dining - Marketplace", "IG Kiosk");
                    addFlow("IG Kiosk");
                    navigate("/solutions/ig-kiosk")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG Kiosk
                    </div>
                    <img src={IGKiosk} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Business & Industry Dining - Marketplace", "IG PanOptic Kiosk");
                    addFlow("IG PanOptic Kiosk");
                    navigate("/solutions/ig-panoptic")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG PanOptic Kiosk
                    </div>
                    <img src={IGPanOpticKiosk} alt="" />
                </div>
            </FeaturedSolutions>
        </div>
    )
}
export default MarketplacePage;